import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string, data: any, masterId: number) =>
  axios.post(
    `${process.env.REACT_APP_API_HOST}/admin/masters/upload?id=${masterId}`,
    data,
    config(token)
  );
